import { useState } from 'react';
import api from '../api';
import { T } from '../styles/theme';

export default function OnboardingModal({ userName, onComplete }) {
  const [step, setStep] = useState(1);
  const [miniForm, setMiniForm] = useState({ name: '', category: '' });
  const [saving, setSaving] = useState(false);

  const CATEGORIES = ['Scarpe', 'Abbigliamento', 'Profumi', 'Tech', 'Borse'];

  const finish = async () => {
    try { await api.patch('/auth/onboarding-step'); } catch {}
    onComplete();
  };

  const handleAddProduct = async () => {
    if (!miniForm.name) return;
    setSaving(true);
    try {
      await api.post('/products', { name: miniForm.name, category: miniForm.category, price: 0, quantity: 1 });
      await finish();
    } catch { setSaving(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(13,11,30,0.95)', backdropFilter: 'blur(8px)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ maxWidth: 500, width: '100%' }}>

        {step === 1 && (
          <div style={{ textAlign: 'center', animation: 'countUp 0.6s ease-out' }}>
            <div style={{ width: 80, height: 80, background: T.gradPrimary, borderRadius: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
              <span style={{ fontFamily: T.fontDisplay, color: 'white', fontWeight: 800, fontSize: '1.8rem' }}>IE</span>
            </div>
            <h1 style={{ fontFamily: T.fontDisplay, fontSize: '2rem', fontWeight: 800, color: T.text, marginBottom: 8 }}>Benvenuto in Impero Elite{userName ? `, ${userName}` : ''}!</h1>
            <p style={{ fontFamily: T.fontBody, color: T.muted, marginBottom: 24 }}>Sei a pochi passi dal gestire il tuo resell come un professionista</p>
            <button onClick={() => setStep(2)} className="btn-primary" style={{ padding: '12px 32px', fontSize: '1rem' }}>Iniziamo →</button>
          </div>
        )}

        {step === 2 && (
          <div style={{ animation: 'countUp 0.6s ease-out' }}>
            <h2 style={{ fontFamily: T.fontDisplay, fontSize: '1.6rem', fontWeight: 800, color: T.text, textAlign: 'center', marginBottom: 24 }}>Come funziona</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
              {[
                { icon: '📦', title: 'Aggiungi prodotti', desc: 'Carica il tuo inventario con foto e dettagli' },
                { icon: '🔍', title: 'Analizza il mercato', desc: 'Trova il prezzo giusto con AI e dati reali' },
                { icon: '🚀', title: 'Vendi e tracka', desc: 'Registra vendite e monitora i profitti' },
              ].map((item, i) => (
                <div key={i} className="card" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                  <span style={{ fontSize: '2rem' }}>{item.icon}</span>
                  <div>
                    <p style={{ fontFamily: T.fontBody, fontWeight: 700, color: T.text }}>{item.title}</p>
                    <p style={{ fontFamily: T.fontBody, fontSize: '0.85rem', color: T.muted }}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <button onClick={() => setStep(3)} className="btn-primary" style={{ width: '100%', padding: 14, justifyContent: 'center', fontSize: '1rem' }}>Capito! →</button>
          </div>
        )}

        {step === 3 && (
          <div style={{ animation: 'countUp 0.6s ease-out' }}>
            <h2 style={{ fontFamily: T.fontDisplay, fontSize: '1.6rem', fontWeight: 800, color: T.text, textAlign: 'center', marginBottom: 8 }}>Aggiungi il tuo primo prodotto</h2>
            <p style={{ fontFamily: T.fontBody, color: T.muted, textAlign: 'center', fontSize: '0.85rem', marginBottom: 24 }}>Inizia con qualcosa di semplice</p>
            <div className="card" style={{ marginBottom: 24 }}>
              <div style={{ marginBottom: 16 }}>
                <label className="label">Nome prodotto</label>
                <input type="text" className="input" value={miniForm.name} onChange={(e) => setMiniForm({ ...miniForm, name: e.target.value })} placeholder="es. Nike Air Force 1" />
              </div>
              <div>
                <label className="label">Categoria</label>
                <select className="input" value={miniForm.category} onChange={(e) => setMiniForm({ ...miniForm, category: e.target.value })}>
                  <option value="">Seleziona...</option>
                  {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
            </div>
            <button onClick={handleAddProduct} disabled={saving || !miniForm.name}
              className="btn-primary" style={{ width: '100%', padding: 14, justifyContent: 'center', fontSize: '1rem', opacity: saving || !miniForm.name ? 0.5 : 1 }}>
              {saving ? 'Aggiunta...' : 'Aggiungi e vai alla dashboard →'}
            </button>
            <button onClick={finish} className="btn-ghost" style={{ width: '100%', marginTop: 8, textAlign: 'center', display: 'block' }}>
              Salta — vai alla dashboard
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
